import styled from "styled-components";
import { Col } from "react-bootstrap";

export const Wrapper = styled.div`
    border-bottom: ${globalThis.config.border.small};
    height: 40px;
`;
export const Cells = styled.div`
    display: flex;
    background-color: ${(props) =>
        props.highlighted
            ? globalThis.config.colors.gray9
            : globalThis.config.colors.white};
    height: 100%;
`;
export const AllocationColumn = styled(Col)`
    background: ${(props) =>
        props.disabled ? globalThis.config.colors.gray8 : "transparent"};
    border-right: ${globalThis.config.border.small};
    padding: 0;
    text-align: center;
    border-right: ${(props) =>
        props.outlined?.right
            ? globalThis.config.border.cellAlert
            : globalThis.config.border.small};
    border-left: ${(props) =>
        props.outlined?.left ? globalThis.config.border.cellAlert : "none"};
    border-top: ${(props) =>
        props.outlined?.top ? globalThis.config.border.cellAlert : "none"};
    border-bottom: ${(props) =>
        props.outlined?.bottom ? globalThis.config.border.cellAlert : "none"};
`;
